import { useAtomValue } from "jotai";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "~/components/ui/dropdown-menu";
import { ArrowDownIcon } from "~/components/ui/icons/arrow-down";
import { DownloadIcon } from "~/components/ui/icons/download";
import { Loader } from "~/components/ui/loader";
import { toast } from "~/components/ui/toast";
import {
  FileExtension,
  useBillingExportQuery,
} from "~/graphql/graphql-new.gen";
import { activeSaleIdState } from "~/stores/sales";

export function BillingExportMenu() {
  const { t } = useTranslation();

  const activeSaleId = useAtomValue(activeSaleIdState);
  const [exportTypeBilling, setExportTypeBilling] = useState(FileExtension.Csv);
  const exportTypeBillingOptions = [
    {
      label: t("invoice.export_menu.download_csv"),
      value: FileExtension.Csv,
      onSelect: () => {
        setExportTypeBilling(FileExtension.Csv);
        getExportOrders();
      },
    },
    {
      label: t("invoice.export_menu.download_xls"),
      value: FileExtension.Xlsx,
      onSelect: () => {
        setExportTypeBilling(FileExtension.Xlsx);
        getExportOrders();
      },
    },
  ];

  const { isFetching, refetch: refetchExportOrders } = useBillingExportQuery(
    {
      saleId: activeSaleId ?? "",
      input: {
        fileExtension: exportTypeBilling,
      },
    },
    {
      enabled: false,
    },
  );

  const getExportOrders = async () => {
    const result = await refetchExportOrders();

    if (result.data) {
      if (result.data.billingExport.fileUrl) {
        window.open(result.data.billingExport.fileUrl, "_self");
        toast.success(result.data.billingExport.fileUrl);
      } else {
        toast.success(t("orders.empty_result"));
      }
    }
  };

  if (isFetching) {
    return <Loader className="size-6" />;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex shrink-0 items-center [&[data-state=open]_svg]:rotate-180">
        <div className="flex items-center space-x-2">
          <span className="text-sm font-semibold text-green-900">
            {t("invoice.export_menu.label")}
          </span>
          <ArrowDownIcon className="size-4 shrink-0 transition-all" />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        sideOffset={8}
        className="min-w-52 overflow-y-auto"
        style={{
          maxHeight: "var(--radix-dropdown-menu-content-available-height)",
        }}
      >
        {exportTypeBillingOptions.map((option) => (
          <DropdownMenuItem
            key={option.value}
            onSelect={option.onSelect}
            className="space-x-2"
          >
            <DownloadIcon className="size-6" />
            <p>{option.label}</p>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
